import core from '../modules/core';
import store from '@/store/store'
import utils from '@/utils/utils'

export default {
  base(parameters={}) {
    return core.call({
      url: '/api/v1/eduplanmap/base',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    });   
 
  },

  product(parameters={}) {
    return core.call({
      url: '/api/v1/eduplanmap/product',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    });   
 
  },
  
  child(parameters={}) {
    return core.call({
      url: '/api/v1/eduplanmap/child',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  
  customerPlan(parameters={}) {
    return core.call({
      url: '/api/v1/eduplanmap/customerPlan',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },

  bascket(parameters={}) {
    return core.call({
      url: '/api/v1/eduplanmap/bascket',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },

  myPlan(parameters={}) {
    return core.call({
      url: '/api/v1/eduplanmap/mylist',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  myPlanSave(parameters={}) {
    return core.call({
      url: '/api/v1/eduplanmap/save',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid"),
        'blockYn': 'Y'
      }    
    }); 
  },
  myPlanDel(parameters={}) {
    return core.call({
      url: '/api/v1/eduplanmap/delMyPlan',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid"),
        'blockYn': 'Y'
      }    
    }); 
  },
  myPlanReNm(parameters={}) {
    return core.call({
      url: '/api/v1/eduplanmap/rename',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid"),
        'blockYn': 'Y'
      }    
    }); 
  },

  promotion(parameters={}) {
    return core.call({
      url: '/api/v1/eduplanmap/promotion',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  }

}
